import { Nav } from "rsuite";

const { Item } = Nav;

export const ProfileNav = ({
  items,
  active,
  onSelect,
  ...props
}: {
  items: string[];
  active: string;
  onSelect: (activeKey: string) => void;
}) => {
  return (
    <Nav
      {...props}
      className="mb-3 p-0 nav-company"
      appearance="subtle"
      justified
      activeKey={active}
      onSelect={onSelect}
    >
      {items.map((item) => (
        <Item className="bg-white text-center" eventKey={item}>
          <p className="p-3">{item}</p>
        </Item>
      ))}
    </Nav>
  );
};
